import { render, staticRenderFns } from "./BAbout.vue?vue&type=template&id=39408eea&scoped=true&"
var script = {}
import style0 from "./BAbout.vue?vue&type=style&index=0&id=39408eea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39408eea",
  null
  
)

export default component.exports